import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import FooterLinks from 'PointOfSale/modules/common/component/FooterLinks';
import * as groupActions from 'PointOfSale/modules/group/state/actions';

class GroupFooterContainer extends Component {
  onCheckoutClicked = () => {
    this.props.groupActions.checkout();
  };

  render() {
    const { profiles, Id } = this.props;
    return Id ? (
      <FooterLinks
        options={[
          {
            type: 'Checkout',
            isDisabled: !_.some(profiles, 'selected'),
          },
        ]}
        onClickHandler={this.onCheckoutClicked}
      />
    ) : null;
  }
}

GroupFooterContainer.propTypes = {
  isSelectedForCheckout: PropTypes.bool,
  groupActions: PropTypes.object,
  Id: PropTypes.number,
};

const mapStateToProps = state => ({
  profiles: state.PointOfSaleState.group.profiles,
  isSelectedForCheckout: state.PointOfSaleState.group.isSelectedForCheckout,
  Id: state.PointOfSaleState.group.Id,
});

const mapDispatchToProps = dispatch => ({
  groupActions: bindActionCreators(groupActions, dispatch),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GroupFooterContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/container/GroupFooterContainer.js